// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ot__","colMin":"styles_colMin__3sWgh"};